import React from 'react'
import "../healthy_kitchen/HealthyKitchen.css"
import { Col, Container, Row } from 'react-bootstrap'
const HealthyKitchen = () => {
  return (
    <>
      <section id="healthy_kitchen">
        <Container>
          <Row>
            <Col lg={6}>
              <div class="healthy_kitchen_manu">
                <div class="healthy_kitchen_text">
                  <h4>Save Up to 15%</h4>
                  <h1>Healthy Kitchen
                    with Fresh </h1>
                    <p>Shop Now</p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div class="healthy_kitchen_minu">
                <div class="healthy_kitchen_text">
                  <h4>Save Up to 15%</h4>
                  <h1>Healthy Kitchen
                    with Fresh </h1>
                    <p>Shop Now</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
  </section>
    </>
  )
}

export default HealthyKitchen